import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class NextBusinessDayPreSelectionFeature implements IFlagFeature {
  name = Features.NEXT_BUSINESS_DAY_PRE_SELECTION;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
